import script from "./cashBackCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./cashBackCard.vue?vue&type=script&lang=ts&setup=true"

import "./cashBackCard.vue?vue&type=style&index=0&id=78964fde&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78964fde"]])

export default __exports__